"use client";

import { useState } from "react";
import { Card } from "@rosette/web_components/src/ui/Card.js";
import { Form } from "@/components/form/Form.js";
import { SubmitButton } from "@/components/form/SubmitButton.js";
import { Label } from "@rosette/web_components/src/ui/Label.js";
import { TextInput } from "@rosette/web_components/src/ui/TextInput.js";


interface SubscribeToRoyalListPromptProps {
    source: string;
}


export function SubscribeToRoyalListPrompt({ source }: SubscribeToRoyalListPromptProps) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const nameError = (
        name.length === 0 ? "Please provide a name" : null
    );
    const emailError = (
        email.length === 0 ? "Please provide your email" : null
    );
    const validationError = nameError ?? emailError;

    return (
        <div className="w-full py-9">
            <Card tone="reading" className="mx-auto max-w-xl">
                <Form
                    className="[&_button]:mt-4"
                    action="/email/sub"
                    skipRefreshOnSubmit={true}
                    validationError={validationError}>

                    <p className="m-0 text-xl font-bold text-strong">
                        Would you like to hear about future updates?
                    </p>
                    <p className="my-3">
                        Join our newsletter and we&apos;ll send you emails
                        when we have new updates or Royal Game of Ur news to share 📮
                        We also send photos of cool boards! 🖼️
                    </p>

                    <Label htmlFor="name">
                        Your Name
                    </Label>
                    <TextInput
                        type="text"
                        id="name"
                        name="name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required={true} />

                    <Label htmlFor="email">
                        Your Email
                    </Label>
                    <TextInput
                        type="text"
                        id="email"
                        name="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        required={true} />

                    <input
                        type="hidden"
                        id="source"
                        name="source"
                        value={source} />

                    <SubmitButton label="Join" />
                </Form>
            </Card>
        </div>
    );
}
